import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { workspaceService } from '@/services/workspace';

export const fetchWorkspace = createAsyncThunk(
    '/fetchWorkspace',
    async (workspaceId: string) => {
        const response = await workspaceService.fetchWorkspace(workspaceId)
        return response
    }
)

const workspaceSlice = createSlice({
    name: 'workspace',
    initialState: {
        workspace: [],
        status: 'idle',
        error: null as string | null
    },
    reducers: {
        setWorkspace: (state, action: PayloadAction<any>) => {
            state.workspace = action.payload
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchWorkspace.pending, (state, action) => {
            state.status = 'loading'
        })
        builder.addCase(fetchWorkspace.fulfilled, (state, action) => {
            state.status = 'succeeded'
            state.workspace = action.payload
        })
        builder.addCase(fetchWorkspace.rejected, (state, action) => {
            state.status = 'failed'
            state.error = action.error.message || null
        })
    }
})

export const { setWorkspace } = workspaceSlice.actions
export default workspaceSlice.reducer